module.exports = __webpack_public_path__ + "static/img/Tyler-Welsh.10d909f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyler-Welsh.jpg
// module id = wCaP
// module chunks = 0